export default __webpack_public_path__ + "static/media/DramaticDocumentary.b42ee206.mp3";